module.exports = __webpack_public_path__ + "img/personal-detail.07928bab.svg";